
(function(){
  function startHero(){
    var v=document.querySelector('.blv-instant-hero');
    if(!v) return;
    v.muted=true;
    v.defaultMuted=true;
    v.playsInline=true;
    v.setAttribute('muted','');
    v.setAttribute('playsinline','');
    try{
      var p=v.play();
      if(p && typeof p.catch==='function'){p.catch(function(){});}
    }catch(e){}
  }
  startHero();
  document.addEventListener('DOMContentLoaded', startHero, {once:true});
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden) startHero();
  });
})();
